import React from "react";
import "devextreme/dist/css/dx.light.css";
import DataGrid, {
  Column,
  Paging,
  Pager,
  Selection,
  Editing,
  Popup as DataGridPopup,
  Form as DataGridForm,
  Button as ButtonGrid,
} from "devextreme-react/data-grid";
import "./EnvironmentDatagrid.scss";
import { Item, RequiredRule, GroupItem } from "devextreme-react/form";
import PropTypes from "prop-types";
import { Button } from "devextreme-react/button";
import {
  envCopyButtonSVG,
  editEnvSVG,
  viewDivSVG,
  envUrlCopyLinkSVG,
} from "../../Assets/SVGs/environmentSVGs";
import Notification from "../Notification/Notification";

const EnvironmentDataGrid = ({
  customStore,
  copyToClipboard,
  formatStatus,
  supRole,
  orgRole,
  toggleEditEnvs,
  engineReaderRole,
  operationalReaderRole,
  viewDataReceipt,
}) => {
  const envGrid = () => {
    const copyUrlToClipboard = (e) => {
      navigator.clipboard.writeText(e);
      Notification("Access URL Copied Successfully", "success");
    };
    return (
      <div className="datagrid-wrapper">
        <DataGrid dataSource={customStore} hoverStateEnabled={true} showBorders={true}>
          <Paging defaultPageSize={10} />
          <Pager showNavigationButtons={true} />
          <Editing mode="popup" allowUpdating={true} useIcons={true}>
            <DataGridPopup
              title="Update Environment info"
              showTitle={true}
              width={820}
              height={320}
            />
            <DataGridForm>
              <Item itemType="group" colCount={2} colSpan={2}>
                <GroupItem>
                  <Item dataField="name">
                    <RequiredRule message="Name is required" />
                  </Item>
                  <Item dataField="description">
                    <RequiredRule message="Description is required" />
                  </Item>
                  <Item dataField="active" editorType="dxCheckBox" />
                </GroupItem>
                <GroupItem>
                  <Item dataField="accessUrl">
                    <RequiredRule mesage="AccessUrl is required" />
                  </Item>
                </GroupItem>
              </Item>
            </DataGridForm>
          </Editing>
          <Selection mode="single" />
          <Column dataField="name" caption="Name" width="10%" />
          <Column dataField="description" caption="Description" visible={false} />
          <Column dataField="appRegistrationId" caption="Client ID" width="30%" />
          <Column caption="" type="buttons" name="envCopyButton" width="4%">
            <ButtonGrid onClick={copyToClipboard}>
              <div className="copyDiv">
                <span className="copyButton">{envCopyButtonSVG} </span>
              </div>
            </ButtonGrid>
          </Column>
          <Column
            className="url-column"
            dataField="accessUrl"
            caption="URL"
            width={100}
            cellRender={(cellData) => (
              <Button
                onClick={() => copyUrlToClipboard(cellData?.data.accessUrl)}
                className="urlDiv"
                stylingMode="text"
                height={20}
                width={20}
              >
                <span>{envUrlCopyLinkSVG}</span>
                &nbsp;
                <span>Copy link</span>
                <span className="tooltiptextForUrl">{cellData?.data.accessUrl}</span>
              </Button>
            )}
          />
          <Column
            dataField="certificates[0].thumbprint"
            caption="Thumbprint ID"
            width="38%"
          />
          <Column
            dataField="createdOn"
            dataType="date"
            format="MMM dd, yyyy"
            caption="Created on"
            width="12%"
          />
          <Column
            dataField="certificates[0].endDateTime"
            dataType="date"
            format="MMM dd, yyyy"
            caption="Cert expiry"
            width="12%"
          />
          <Column
            dataField="active"
            dataType="string"
            caption="Status"
            customizeText={formatStatus}
            width="7%"
          />
          <Column caption="Action" type="buttons" name="envViewButton" width="7%">
            {(supRole || orgRole) === true ? (
              <ButtonGrid onClick={toggleEditEnvs}>
                <span className="editEnvIcon">{editEnvSVG}</span>
              </ButtonGrid>
            ) : (
              <div />
            )}
            {(engineReaderRole || operationalReaderRole) === true ? (
              <ButtonGrid onClick={viewDataReceipt}>
                <span className="viewDiv">
                  <span>{viewDivSVG}</span>
                </span>
              </ButtonGrid>
            ) : (
              <div />
            )}
          </Column>
        </DataGrid>
      </div>
    );
  };
  return envGrid();
};
EnvironmentDataGrid.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  customStore: PropTypes.object,
  copyToClipboard: PropTypes.func.isRequired,
  formatStatus: PropTypes.func.isRequired,
  supRole: PropTypes.bool.isRequired,
  orgRole: PropTypes.bool.isRequired,
  toggleEditEnvs: PropTypes.func.isRequired,
  engineReaderRole: PropTypes.bool.isRequired,
  operationalReaderRole: PropTypes.bool.isRequired,
  viewDataReceipt: PropTypes.func.isRequired,
};
export default EnvironmentDataGrid;
